<select
  class="form-control timepicker-select {{ extraClasses }}"
  [ngModel]="selectedTime"
  (ngModelChange)="valueChanged($event)">
  <option *ngFor="let time of times" [ngValue]="time.value" class="fw-bold">
    {{ time.display }}
  </option>
</select>
